const MyJustDate = (date) => {
  if (!date) {
    return null;
  }

  const newDate = new Date(date);

  if (isNaN(newDate)) {
    return null;
  }

  newDate.setHours(0, 0, 0, 0); // Normalize the time to the start of the day
  return newDate;
};

export default MyJustDate;
